module.exports = __webpack_public_path__ + "img/icon_5.e571f0e9.png";